import { IPromise } from 'angular';
import * as _ from 'underscore';
import { getViewInfos } from '../../app/sagas/spaces/SpacesSagaHelpers';
import { DeleteCollectionData } from '../../app/spaces/Collections/CollectionModels';
import { CollectionsResourceQuery } from '../../app/spaces/Collections/Collections';
import { Formatters, Messages } from '../../codegen/Localize';
import {
  openReactConfirmationDialog,
  ReactConfirmationDialogAreYouSureBody
} from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { toQPromise } from '../../commonInfra/utils/QUtils';
import { Projects } from '../../projects/resources/Projects';
import { Views } from '../../views/resources/Views';
import { DataAlerts } from '../../dda/resources/DataAlerts';
import { IMetricInfo } from '../../metrics/models/IMetricInfo';
import { Metrics } from '../../metrics/resources/Metrics';
import { MetricErrors } from '../../metrics/services/MetricErrors';
import { IScheduleInfo } from '../../schedule/types/IScheduleInfo';
import { IActionContext } from '../helpers/ActionContext';
import { ResultHelper } from '../helpers/ResultHelper';
import { L10n } from '../L10n/L10n';
import { CollectionMapper } from '../mappers/CollectionMapper';
import { ExplorableItemType } from '../models/ContentType';
import { FlowListItemInfo } from '../models/FlowInfo';
import { IContentInfo } from '../models/IContentInfo';
import { IDataAlertBase } from '../models/IDataAlertInfo';
import { IDataRoleInfo } from '../models/IDataRoleInfo';
import { IDataSourceInfo } from '../models/IDataSourceInfo';
import { IProjectInfo } from '../models/IProjectInfo';
import { IPublishedConnectionInfo } from '../models/IPublishedConnectionInfo';
import { IViewInfo } from '../models/IViewInfo';
import { IWorkbookInfo, IWorkbookParentInfo } from '../models/IWorkbookInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataRoles } from '../resources/Dataroles';
import { DataSources } from '../resources/Datasources';
import { Flows } from '../resources/Flows';
import { PublishedConnections } from '../resources/PublishedConnections';
import { RunFlowTasks } from '../resources/RunFlowTasks';
import { Schedules } from '../resources/Schedules';
import { Workbooks } from '../resources/Workbooks';
import { CustomViews } from '../ServerApi/CustomViews/CustomViews';
import { ICustomViewInfo } from '../ServerApi/CustomViews/ICustomViewInfo';
import { ContentDraftStatus } from '../ServerApi/types/ContentDraft';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { CollectionErrors } from './CollectionErrors';
import { actionErrorTranslation, actionSuccessTranslation } from './ContentActionNotification';
import { CustomViewErrors } from './customViews/CustomViewErrors';
import { DataAlertErrors } from './DataAlertErrors';
import { DataRoleErrors } from './DataRoleErrors';
import { DataSourceErrors } from './DataSourceErrors';
import { DeleteRunFlowTasksAction } from './DeleteRunFlowTasksAction';
import { DeleteSchedulesAction } from './DeleteSchedulesAction';
import { FlowErrors } from './FlowErrors';
import { HideViewsAction } from './HideViewsAction';
import { ProjectErrors } from './ProjectErrors';
import { PublishedConnectionErrors } from './PublishedConnectionErrors';
import { ScheduleErrors } from './ScheduleErrors';
import { ViewErrors } from './ViewErrors';
import { WorkbookErrors } from './WorkbookErrors';

export interface ContentTypeAndID {
  contentType: ExplorableItemType;
  id: string;
}
export interface IDeleteContentsResult extends IResult {
  deletedItems: ContentTypeAndID[];
}

export class DeleteContentsAction {

  public static $inject = ['WorkbookErrors', 'ProjectErrors', 'DataRoleErrors', 'DataSourceErrors', 'ViewErrors', 'FlowErrors',
    '$translate', 'Workbooks', 'DataSources', 'Flows', 'PublishedConnections', 'DataRoles', '$q', 'DataAlertErrors',
    'ScheduleErrors', 'Schedules', 'DeleteSchedulesAction', 'DeleteRunFlowTasksAction', 'RunFlowTasks'
  ];

  constructor(
    private WorkbookErrors: WorkbookErrors,
    private ProjectErrors: ProjectErrors,
    private DataRoleErrors: DataRoleErrors,
    private DataSourceErrors: DataSourceErrors,
    private ViewErrors: ViewErrors,
    private FlowErrors: FlowErrors,
    private $translate: ng.translate.ITranslateService,
    private Workbooks: Workbooks,
    private DataSources: DataSources,
    private Flows: Flows,
    private PublishedConnections: PublishedConnections,
    private DataRoles: DataRoles,
    private $q: ng.IQService,
    private DataAlertErrors: DataAlertErrors,
    private ScheduleErrors: ScheduleErrors,
    private Schedules: Schedules,
    private DeleteSchedulesActions: DeleteSchedulesAction,
    private DeleteRunFlowTasksAction: DeleteRunFlowTasksAction,
    private RunFlowTasks: RunFlowTasks) {
  }

  public confirmDeleteContents(contents: IContentInfo[], context: IActionContext): ng.IPromise<IDeleteContentsResult> {
    let projects: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let workbooks: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let dataRoles: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let datasources: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let views: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let flows: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let publishedConnections: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let collections: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let metrics: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let alerts: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let schedules: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let runFlowTasks: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let customViews: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    contents.forEach((contentItem) => {
      switch (contentItem.contentType) {
        case 'project':
          projects.add(contentItem);
          break;
        case 'workbook':
          workbooks.add(contentItem);
          break;
        case 'dataRole':
          dataRoles.add(contentItem);
          break;
        case 'datasource':
          datasources.add(contentItem);
          break;
        case 'view':
          views.add(contentItem);
          break;
        case 'flow':
          flows.add(contentItem);
          break;
        case 'publishedConnection':
          publishedConnections.add(contentItem);
          break;
        case 'collection':
          collections.add(contentItem);
          break;
        case 'metric':
          metrics.add(contentItem);
          break;
        case 'dataalert':
          alerts.add(contentItem);
          break;
        case 'schedule':
          schedules.add(contentItem);
          break;
        case 'runFlowTask':
          runFlowTasks.add(contentItem);
          break;
        case 'customView':
          customViews.add(contentItem);
          break;
        default:
          break;
      }
    });

    let workbooksToBeDeleted: IWorkbookParentInfo[] = [];
    let dialogBody: string = '';
    let determineWorkbooksToBeDeletedPromise: IPromise<IViewInfo[]>;
    if (views.size() > 0) {
      determineWorkbooksToBeDeletedPromise = getViewInfos(views.toArray());
    } else {
      determineWorkbooksToBeDeletedPromise = Q.when([]) as ng.IPromise<IViewInfo[]>;
    }

    return determineWorkbooksToBeDeletedPromise.then((viewDetailArray: IViewInfo[]) => {
      if (views.size() > 0) {
        workbooksToBeDeleted = HideViewsAction
          .determineWorkbooksToBeDeleted(Set.fromIdItemArray(viewDetailArray));
      }
      dialogBody = this.buildConfirmationDialog(contents, workbooksToBeDeleted);
      return this.buildDialogBox(
        context,
        dialogBody,
        contents,
        projects,
        workbooks,
        dataRoles,
        datasources,
        views,
        flows,
        publishedConnections,
        collections,
        metrics,
        alerts,
        schedules,
        runFlowTasks,
        customViews);
    });
  }

  private buildDialogBox(
    context: IActionContext,
    dialogBody: string,
    contents: IContentInfo[],
    projects: Set<IContentInfo>,
    workbooks: Set<IContentInfo>,
    dataRoles: Set<IContentInfo>,
    datasources: Set<IContentInfo>,
    views: Set<IContentInfo>,
    flows: Set<IContentInfo>,
    publishedConnections: Set<IContentInfo>,
    collections: Set<IContentInfo>,
    metrics: Set<IContentInfo>,
    alerts: Set<IContentInfo>,
    schedules: Set<IContentInfo>,
    runFlowTasks: Set<IContentInfo>,
    customViews: Set<IContentInfo>
  ): PromiseLike<IDeleteContentsResult> {

    const initialModalInstance = openReactConfirmationDialog<void, IDeleteContentsResult>({
      title: Messages.deleteMessage(),
      message: dialogBody,
      paramsForAction: undefined,
      actionName: Messages.confirmDeleteButton({ ITEM_COUNT: contents.length, ITEM_COUNT_LOC: Formatters.formatCount(contents.length) }),
      //If the set of content items included any projects, we defer deletion until a second 'Are you sure' confirmation is given. If no projects are being deleted, proceed after the user clicks 'Delete'
      action: () => {
        return projects.size() > 0
          ? null
          : this.deleteContent(projects, workbooks, dataRoles, datasources, views, flows, publishedConnections, collections, metrics, alerts, schedules, runFlowTasks, customViews);
      },
      isActionDelete: true,
      dialogWidth: TabDialogWidth.width375px
    });

    return initialModalInstance.result.then((result) => {
      initialModalInstance.dismiss();

      if (projects.size() === 0) {
        //Content is deleted, no second confirmation is needed
        return result;
      }

      const modalInstance = openReactConfirmationDialog<void, IDeleteContentsResult>({
        bodyComponent: ReactConfirmationDialogAreYouSureBody,
        message: Messages.actionNotUndoable(),
        paramsForAction: undefined,
        actionName: Messages.confirmDeleteProjectsDefinitely({ PROJECT_COUNT: projects.size() }),
        action: () => {
          return this.deleteContent(projects, workbooks, dataRoles, datasources, views, flows, publishedConnections, collections, metrics, alerts, schedules, runFlowTasks, customViews);
        },
        isActionDelete: true,
        centerActionButtons: true,
        dialogWidth: TabDialogWidth.width375px
      });
      return modalInstance.result;
    });
  }

  private deleteContent(
    projects: Set<IContentInfo>,
    workbooks: Set<IContentInfo>,
    dataRoles: Set<IContentInfo>,
    datasources: Set<IContentInfo>,
    views: Set<IContentInfo>,
    flows: Set<IContentInfo>,
    publishedConnections: Set<IContentInfo>,
    collections: Set<IContentInfo>,
    metrics: Set<IContentInfo>,
    alerts: Set<IContentInfo>,
    schedules: Set<IContentInfo>,
    runFlowTasks: Set<IContentInfo>,
    customViews: Set<IContentInfo>
  ): IPromise<IDeleteContentsResult> {
    let aggregateResult: IDeleteContentsResult[] = [];
    let outstandingPromises: IPromise<IResult>[] = [];

    if (projects.size() > 0) {
      const deleteProjects = Projects.del(projects.map(item => item.id));
      outstandingPromises.push(deleteProjects);
      deleteProjects.then(
        (result: IResult) => {
          const deletedProjects: ContentTypeAndID[] = getActuallyDeletedItems(projects, result);
          aggregateResult.push({ deletedItems: deletedProjects, errors: result.errors });
          ActionHelpers.notifyStandardError(
            projects,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteProjectsSuccess),
              error: actionErrorTranslation(Messages.deleteProjectsError),
            },
            (errorItem: IErrorItem<IProjectInfo>) => this.ProjectErrors.errorDetailsFor(errorItem));
        });
    }
    if (workbooks.size() > 0) {
      const deleteWorkbooks = this.Workbooks.del(workbooks.map(item => item.id));
      outstandingPromises.push(deleteWorkbooks);
      deleteWorkbooks.then(
        (result: IResult) => {
          const deletedWorkbooks: ContentTypeAndID[] = getActuallyDeletedItems(workbooks, result);
          aggregateResult.push({ deletedItems: deletedWorkbooks, errors: result.errors });
          ActionHelpers.notifyStandardError(
            workbooks,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteWorkbooksSuccess),
              error: actionErrorTranslation(Messages.deleteWorkbooksError),
            },
            (errorItem: IErrorItem<IWorkbookInfo>) => this.WorkbookErrors.errorDetailsFor(errorItem));
        });
    }
    if (dataRoles.size() > 0) {
      const deleteDataRoles = this.DataRoles.deleteDataRoles(dataRoles.map(item => item.id));
      outstandingPromises.push(deleteDataRoles);
      deleteDataRoles.then(
        (result: IResult) => {
          const deletedDRs: ContentTypeAndID[] = getActuallyDeletedItems(dataRoles, result);
          aggregateResult.push({ deletedItems: deletedDRs, errors: result.errors });
          ActionHelpers.notifyStandardError(
            dataRoles,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteDataRolesSuccess),
              error: actionErrorTranslation(Messages.deleteDataRolesError),
            },
            (errorItem: IErrorItem<IDataRoleInfo>) => this.DataRoleErrors.errorDetailsFor(errorItem));
        });
    }
    if (datasources.size() > 0) {
      const deleteDatasources = this.DataSources.del(datasources.map(item => item.id));
      outstandingPromises.push(deleteDatasources);
      deleteDatasources.then(
        (result: IResult) => {
          const deletedDSs: ContentTypeAndID[] = getActuallyDeletedItems(datasources, result);
          aggregateResult.push({ deletedItems: deletedDSs, errors: result.errors });
          ActionHelpers.notifyStandardError(
            datasources,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteDatasourcesSuccess),
              error: actionErrorTranslation(Messages.deleteDatasourcesError),
            },
            (errorItem: IErrorItem<IDataSourceInfo>) => this.DataSourceErrors.errorDetailsFor(errorItem));
        });
    }
    if (views.size() > 0) {
      const deleteViews = Views.hide(views.map(item => item.id));
      outstandingPromises.push(deleteViews);
      deleteViews.then(
        (result: IResult) => {
          const deletedViews: ContentTypeAndID[] = getActuallyDeletedItems(views, result);
          aggregateResult.push({ deletedItems: deletedViews, errors: result.errors });
          ActionHelpers.notifyStandardError(
            views,
             result,
             {
              success: actionSuccessTranslation(Messages.deleteViewsSuccess),
              error: actionErrorTranslation(Messages.deleteViewsError),
            },
            (errorItem: IErrorItem<IViewInfo>) => this.ViewErrors.errorDetailsFor(errorItem));
        });
    }
    if (flows.size() > 0) {
      const actualFlows = flows.filter(flow => {
        return flow.draftStatus !== ContentDraftStatus.unpublished;
      });
      if (actualFlows.size() > 0) {
        const deleteFlows = this.Flows.deleteFlows(actualFlows.map(item => item.id));
        outstandingPromises.push(deleteFlows);
        deleteFlows.then(
          (result: IResult) => {
            const deletedFlows: ContentTypeAndID[] = getActuallyDeletedItems(actualFlows, result);
            aggregateResult.push({ deletedItems: deletedFlows, errors: result.errors });
            ActionHelpers.notifyStandardError(
              actualFlows,
              result,
              {
                success: actionSuccessTranslation(Messages.deleteFlowsSuccess),
                error: actionErrorTranslation(Messages.deleteFlowsError),
              },
              (errorItem: IErrorItem<FlowListItemInfo>) => this.FlowErrors.errorDetailsFor(errorItem));
          });
      }

      const flowDrafts = flows.filter(flow => {
        return flow.draftStatus === ContentDraftStatus.unpublished;
      });
      if (flowDrafts.size() > 0) {
        const deleteFlowDrafts = this.Flows.deleteFlowDrafts(flowDrafts.map(item => item.id));
        outstandingPromises.push(deleteFlowDrafts);
        deleteFlowDrafts.then(
          (result: IResult) => {
            const deletedFlows: ContentTypeAndID[] = getActuallyDeletedItems(flowDrafts, result);
            aggregateResult.push({ deletedItems: deletedFlows, errors: result.errors });
            ActionHelpers.notifyStandardError(
              flowDrafts,
              result,
              {
                success: actionSuccessTranslation(Messages.deleteFlowDraft_actionSuccess),
                error: actionErrorTranslation(Messages.deleteFlowDraft_actionFailed),
              },
              (errorItem: IErrorItem<FlowListItemInfo>) => this.FlowErrors.errorDetailsFor(errorItem));
          });
      }
    }
    if (publishedConnections.size() > 0) {
      const deletePublishedConnections = this.PublishedConnections.del(publishedConnections.map(item => item.id));
      outstandingPromises.push(deletePublishedConnections);
      deletePublishedConnections.then(
        (result: IResult) => {
          const deletedPublishedConnections: ContentTypeAndID[] = getActuallyDeletedItems(publishedConnections, result);
          aggregateResult.push({ deletedItems: deletedPublishedConnections, errors: result.errors });
          ActionHelpers.notifyStandardError(
            publishedConnections,
            result,
            {
              success: actionSuccessTranslation(Messages.deletePublishedConnectionsSuccess),
              error: actionErrorTranslation(Messages.deletePublishedConnectionsError),
            },
            (errorItem: IErrorItem<IPublishedConnectionInfo>) => PublishedConnectionErrors.errorDetailsFor(errorItem));
        });
    }
    if (collections.size() > 0) {
      const deleteCollectionsPromise = (new CollectionsResourceQuery()).delete(collections.map(item => item.luid)).then(
        (result: DeleteCollectionData): IResult => {
          return CollectionMapper.mapDeleteCollectionsDataToIResult(result, collections);
        }
      );
      outstandingPromises.push(deleteCollectionsPromise);
      deleteCollectionsPromise.then(
        (result: IResult) => {
          const deletedCollections: ContentTypeAndID[] = getActuallyDeletedItems(collections, result);
          aggregateResult.push({ deletedItems: deletedCollections, errors: result.errors });
          ActionHelpers.notifyStandardError(
            collections,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteCollectionsSuccess),
              error: actionErrorTranslation(Messages.deleteCollectionsError),
            },
            (errorItem: IErrorItem<IContentInfo<'collection'>>) => CollectionErrors.errorDetailsFor(errorItem));
        }).catch((error) => {
          return { errors: [{ code: error.data.errorCode }] } as IResult;
        });
    }
    if (alerts.size() > 0) {
      const deleteAlerts = toQPromise(DataAlerts.del(alerts.map(item => item.id)));
      outstandingPromises.push(deleteAlerts);
      deleteAlerts.then(
        (result: IResult) => {
          const deletedAlerts: ContentTypeAndID[] = getActuallyDeletedItems(alerts, result);
          aggregateResult.push({ deletedItems: deletedAlerts, errors: result.errors });
          ActionHelpers.notifyStandardError<IDataAlertBase>(
            alerts as Set<IDataAlertBase>,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteDataAlertsSuccess),
              error: actionErrorTranslation(Messages.deleteDataAlertsError),
            },
            (errorItem: IErrorItem<IDataAlertBase>) => this.DataAlertErrors.errorDetailFor(errorItem));
        });
    }
    if (schedules.size() > 0) {
      const deleteSchedules = this.Schedules.del(schedules.map(item => item.id));
      outstandingPromises.push(deleteSchedules);
      deleteSchedules.then(
        (result: IResult) => {
          const deleteSchedules: ContentTypeAndID[] = getActuallyDeletedItems(schedules, result);
          aggregateResult.push({ deletedItems: deleteSchedules, errors: result.errors });
          ActionHelpers.notifyStandardError<IScheduleInfo>(
            schedules as unknown as Set<IScheduleInfo>,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteSchedulesSuccess),
              error: actionErrorTranslation(Messages.deleteSchedulesError),
            },
            (errorItem: IErrorItem<IScheduleInfo>) => this.ScheduleErrors.errorDetailsFor(errorItem));
        });
    }
    if (runFlowTasks.size() > 0) {
      const deleteRunFlowTasks = this.RunFlowTasks.del(runFlowTasks.map(item => item.id));
      outstandingPromises.push(deleteRunFlowTasks);
      deleteRunFlowTasks.then(
        (result: IResult) => {
          const deletedRunFlowTasks: ContentTypeAndID[] = getActuallyDeletedItems(runFlowTasks, result);
          aggregateResult.push({ deletedItems: deletedRunFlowTasks, errors: result.errors });
          ActionHelpers.notifyStandardError<RunFlowTaskInfo>(
            runFlowTasks as unknown as Set<RunFlowTaskInfo>,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteRunFlowTasksSuccess),
              error: actionErrorTranslation(Messages.deleteRunFlowTasksError),
            },
            (errorItem: IErrorItem<RunFlowTaskInfo>) => this.DeleteRunFlowTasksAction.errorDetailFor(errorItem));
        });
    }
    if (metrics.size() > 0) {
      const deleteMetrics = Metrics.del(metrics.map(item => item.id));
      outstandingPromises.push(deleteMetrics);
      deleteMetrics.then(
        (result: IResult) => {
          const deletedMetrics: ContentTypeAndID[] = getActuallyDeletedItems(metrics, result);
          aggregateResult.push({ deletedItems: deletedMetrics, errors: result.errors });
          ActionHelpers.notifyStandardError(
            metrics,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteMetricsSuccess),
              error: actionErrorTranslation(Messages.deleteMetricsError),
            },
            (errorItem: IErrorItem<IMetricInfo>) => MetricErrors.errorDetailsFor(errorItem)
          );
        });
    }
    if (customViews.size() > 0) {
      const deleteCustomViews = CustomViews.del(customViews.map(item => item.id));
      outstandingPromises.push(deleteCustomViews);
      deleteCustomViews.then(
        (result: IResult) => {
          const deletedCustomViews: ContentTypeAndID[] = getActuallyDeletedItems(customViews, result);
          aggregateResult.push({ deletedItems: deletedCustomViews, errors: result.errors });
          ActionHelpers.notifyStandardError(
            customViews as unknown as Set<ICustomViewInfo>,
            result,
            {
              success: actionSuccessTranslation(Messages.deleteCustomViewsSuccess),
              error: actionErrorTranslation(Messages.deleteCustomViewsError),
            },
            (errorItem: IErrorItem<ICustomViewInfo>) => CustomViewErrors.errorDetailsFor(errorItem)
          );
        });
    }
    return this.$q.all(outstandingPromises).then(() => {
      return combineIDeleteContentsResults(aggregateResult);
    });
  }

  private buildConfirmationDialog(contents: IContentInfo[], workbooksToBeDeleted: IWorkbookParentInfo[]): string {
    let dialogBody = '';
    if (contents.length === 1) {
      let contentName;
      if (contents[0].contentType === 'runFlowTask') {
        const runFlowTaskContent: RunFlowTaskInfo = contents[0] as unknown as RunFlowTaskInfo;
        contentName = runFlowTaskContent.flow.name;
      } else {
        contentName = contents[0].name;
      }

      if (contents[0].contentType === 'schedule') {
        return this.DeleteSchedulesActions.deleteSingleScheduleBodyText(contents[0] as unknown as IScheduleInfo);
      }

      dialogBody += Messages.confirmDeleteContent({
        CONTENT_NAME: L10n.elideIfLong(contentName),
        CONTENT_TYPE: L10n.elideIfLong(this.$translate.instant(contents[0].contentType))
      });

      if (contents[0].contentType === 'project') {
        dialogBody += Messages.deleteProjectWarning();
      }

      if (contents[0].contentType === 'collection') {
        dialogBody += Messages.deleteCollectionWarning();
      }
    } else {
      dialogBody += Messages.confirmDeleteContents({
        CONTENT_COUNT_LOC: Formatters.formatCount(contents.length)
      });
    }

    if (workbooksToBeDeleted.length > 0) {
      const workbooksWarning = Messages.confirmDeleteViewsWorkbookWarning({
        WORKBOOK_COUNT: workbooksToBeDeleted.length,
        WORKBOOK_COUNT_LOC: Formatters.formatCount(workbooksToBeDeleted.length),
        WORKBOOK_NAME: L10n.elideIfLong(workbooksToBeDeleted[0].name)
      });
      dialogBody = dialogBody + ' ' + workbooksWarning;
    }
    return dialogBody;
  }
}

// exported for testing
export function getActuallyDeletedItems(items: Set<IContentInfo<ExplorableItemType>>, result: IResult): ContentTypeAndID[] {
  const deletedItems: ContentTypeAndID[] = [];
  items.each((item: IContentInfo<ExplorableItemType>) => {
    if (result.errors && !_.any(result.errors, (error: IError) => {
      return (item.contentType === 'collection') ? (error.id === item.luid) : (error.id === item.id);
    })) {
      deletedItems.push({ id: item.id, contentType: item.contentType });
    }
  });
  return deletedItems;
}

function combineIDeleteContentsResults(results: IDeleteContentsResult[]): IDeleteContentsResult {
  return {
    deletedItems: ResultHelper.combine(results, (result) => result.deletedItems),
    errors: ResultHelper.combineErrors(results)
  };
}


Module.instance().service('DeleteContentsAction', DeleteContentsAction);
